import {
  AccessibilityNew,
  MailOutline,
  SchoolOutlined,
  SubjectRounded,
} from '@mui/icons-material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

function User() {
  const server_url = process.env.REACT_APP_API_URI;
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const getUserById = async () => {
      try {
        const url = `${server_url}/user/get-user`;
        const response = await axios.post(url, { id });
        setUser(response.data);
      } catch (err) {
        console.log(err);
      }
    };
    getUserById();
  }, [id, server_url]);

  const getUserRole = (role) => {
    const roles = {
      1: 'Admin',
      2: 'Student',
      3: 'Faculty',
      4: 'Guest User',
    };
    return roles[role] || 'Unknown';
  };

  return (
    <div className="flex items-center justify-center min-h-fit bg-gray-100 p-4">
      <div className="bg-white shadow-lg rounded-lg p-6 w-full max-w-md">
        <div className="flex flex-col items-center">
          <img
            src="https://www.citypng.com/public/uploads/preview/png-round-blue-contact-user-profile-icon-11639786938sxvzj5ogua.png"
            alt="User Avatar"
            className="w-24 h-24 rounded-full shadow-md"
          />
          <h2 className="text-xl font-semibold text-gray-700 mt-4">
            {user?.email}
          </h2>
        </div>

        <div className="mt-6 space-y-4">
          <div className="flex items-center space-x-3">
            <SchoolOutlined className="text-blue-500" />
            <span className="text-gray-600">{user?.school || 'N/A'}</span>
          </div>
          <div className="flex items-center space-x-3">
            <SubjectRounded className="text-green-500" />
            <span className="text-gray-600">{user?.subject || 'N/A'}</span>
          </div>
          <div className="flex items-center space-x-3">
            <AccessibilityNew className="text-purple-500" />
            <span className="text-gray-600">{getUserRole(user?.role)}</span>
          </div>
          <div className="flex items-center space-x-3">
            <MailOutline className="text-red-500" />
            <span className="text-gray-600">{user?.email}</span>
          </div>
        </div>

        <button
          onClick={() => navigate('/admin/users')}
          className="mt-6 w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600 transition"
        >
          Back to Users
        </button>
      </div>
    </div>
  );
}

export default User;
